import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.bg = this.el.querySelector('.o-contact_background');
        this.container = this.el.querySelector('.o-contact_container');

        document.querySelectorAll('.contactButton').forEach((btn) => {
            btn.addEventListener('click', () => {
                this.open();
            });
        });

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    open(){
        this.call('stop', 'Scroll');
        this.el.classList.add('-visible');
        gsap.fromTo(
            this.bg,
            { autoAlpha: 0 },
            { autoAlpha: 1, duration: 0.2, ease: "none" }
        );
        gsap.fromTo(
            this.container,
            { y: '100vh', rotate: 15 },
            { y: '0', rotate: 0, duration: 1, ease: "power4.out" }
        );
    }

    close(){
        this.call('start', 'Scroll');
        gsap.to(this.bg, { autoAlpha: 0, duration: 0.2, ease: "none" });
        gsap.to(this.container, { y: '120vh', rotate: 15, duration: 1, ease: "power4.out", onComplete: () => {
            this.el.classList.remove('-visible');
        } });
    }
}
